import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import SoFormContainer from '../../components/layout/SoFormContainer';
import SoFormPaymentForm from './SoFormPaymentForm';
import { useTranslation } from 'react-i18next';

const SoFormStepPaymentBody = ({ className }) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <SoFormContainer>
        <h1>{t('payment.header')}</h1>
        <SoFormPaymentForm />
      </SoFormContainer>
    </div>
  );
};

SoFormStepPaymentBody.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepPaymentBody)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px 0px;
  width: 100%;
  ${SoFormContainer} {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    padding: 0px;
    gap: 16px;
    padding: 0px;
  }
  flex-grow: 1;
`;
